import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../logo.svg';

export default function NavBar() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close the menu whenever the route changes
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const handlePointer = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    const handleKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('mousedown', handlePointer);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handlePointer);
      document.removeEventListener('keydown', handleKey);
    };
  }, [menuOpen]);

  if (!user) return null;

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" aria-label="Ridge Sports home">
          <img src={logo} alt="Ridge Sports" className="navbar-logo" />
        </Link>
      </div>

      <div className="navbar-links">
        <Link to="/">Dashboard</Link>
        <Link to="/shop">Shop</Link>
        {user.supportEmail && (
          <a href={`mailto:${user.supportEmail}`}>Contact Us</a>
        )}
      </div>

      <div className="navbar-menu-wrap" ref={menuRef}>
        <button
          type="button"
          className="nav-menu-toggle"
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="nav-menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="hamburger" />
        </button>

        {menuOpen && (
          <div className="nav-menu" id="nav-menu">
            {isAdmin && (
              <>
                <div className="nav-menu-heading">Admin</div>
                <Link to="/admin/dashboard">Manage Dashboard</Link>
                <Link to="/admin/shop">Manage Shop</Link>
                <Link to="/admin/users">Manage Users</Link>
                <Link to="/admin/general">General Settings</Link>
                <div className="nav-menu-divider" />
              </>
            )}
            <button type="button" className="nav-menu-action" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
